export function proposalSelectionRedirectPath(selection: {
  redirectUrl?: string | null;
}): string | null {
  const path = selection.redirectUrl?.trim();
  // Accept responses from either backend version during rollout.
  if (path?.startsWith('/quote/')) return path.replace('/quote/', '/estimate/');
  return path?.startsWith('/estimate/') ? path : null;
}

/** The public projection publishes this link instead of its internal relationship. */
export function proposalCheckoutEstimateId(proposal: {
  redirectUrl?: string | null;
  materializedEstimateId?: string | null;
}): string | null {
  if (proposal.materializedEstimateId) return proposal.materializedEstimateId;
  const path = proposalSelectionRedirectPath(proposal);
  return path?.match(/^\/estimate\/([^/?#]+)$/)?.[1] ?? null;
}
